import {TabType} from '../search-types';
import {URL_TAB_PARAM} from '../const';

import {parseURI} from '../search.utils';

export function parseOpenTab(tab: string, fallback?: TabType): TabType {
    return TabType[tab.toUpperCase() as keyof typeof TabType] || fallback || TabType.CONTENT;
}

export function encodeTab(tabType?: TabType): string {
    return tabType ? parseURI(URL_TAB_PARAM, tabType.valueOf().toLowerCase()) : '';
}
